import { PermissionRoles } from "@/enum";
import { User } from "@/pages/Public/pages/Login/schema/login";
import { getAllUserPermissions } from "@/utils/user";

/** Signalist's own workspace, the same staff gate the Global Blacklist page uses in the sidebar. */
const SIGNALIST_STAFF_COMPANY_ID = 1;

/**
 * Whether the user may create global blacklist entries, which block a person or company for every
 * workspace (PREC-4347). Mirrors the API's `canManageGlobalBlacklist`: the GLOBAL_ADMIN permission
 * in Signalist's workspace. The checkbox used to show for the role code "ADMIN", which 121
 * customer users hold.
 */
export const canManageGlobalBlacklist = (user: User): boolean =>
	user.company?.id === SIGNALIST_STAFF_COMPANY_ID &&
	getAllUserPermissions(user.roles ?? []).includes(PermissionRoles.GLOBAL_ADMIN);
